import { ReactNode } from 'react';

import cx from 'classnames';

import s from './Media.module.scss';

interface IProps {
  children?: ReactNode;
  className?: string;
}

const Media: React.FC<IProps> = ({ children, className = '' }) => (
  <div className={cx(s.item, className)}>{children}</div>
);

export default Media;
